import { useState } from "react";

import styles from "./StaffAvailabilitySection.module.css";

/**
 * A time input that tells you the format it expects while you type in it, the
 * way CustomCalendar does for a date.
 *
 * The browser's clock popup stays on its icon. App.css used to stretch that
 * icon invisibly over the whole input so any click opened the popup, which
 * made it impossible to dismiss: the click meant to close it landed on the
 * icon and reopened it.
 */
export const TimeField = ({ onFocus, onBlur, ...inputProps }) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (event) => {
    setIsFocused(true);
    onFocus?.(event);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    onBlur?.(event);
  };

  return (
    <div className={styles.timeField}>
      <input
        {...inputProps}
        type="time"
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {!!isFocused && !inputProps.disabled && (
        <div className={styles.timeHint}>💡 Enter time as HH:MM</div>
      )}
    </div>
  );
};
